 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"npm._echarts-wordcloud2.0.0@echarts-wordcloud":"npm._echarts-wordcloud2.0.0@echarts-wordcloud","npm._katex0.6.0@katex":"npm._katex0.6.0@katex","npm._uslug1.0.4@uslug":"npm._uslug1.0.4@uslug","npm._markdown-it6.1.1@markdown-it":"npm._markdown-it6.1.1@markdown-it","npm._unorm1.6.0@unorm":"npm._unorm1.6.0@unorm","npm._antv_layout@0.3.25@@antv":"npm._antv_layout@0.3.25@@antv","npm._antv_g6-core@0.8.24@@antv":"npm._antv_g6-core@0.8.24@@antv","npm._antv_algorithm@0.1.26@@antv":"npm._antv_algorithm@0.1.26@@antv","npm._pdfjs-dist2.6.347@pdfjs-dist":"npm._pdfjs-dist2.6.347@pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-03ef6d8f":"cd9fcb4d","chunk-07ee3900":"e4179989","chunk-0c96d9a1":"3d84913b","chunk-0d602ac2":"579afd6e","chunk-173ecc1a":"32d39304","chunk-1a201cc9":"170bbd22","chunk-1be7006e":"9302a35c","chunk-2d0e17b4":"a851928c","chunk-2f078ddd":"5c9d3393","chunk-6b7734eb":"fb8acc47","chunk-6bca0f1c":"b2960d67","chunk-751da34f":"f493e309","chunk-77df227e":"e940ba24","chunk-783635cf":"444553ba","chunk-7850ab1e":"31db590f","chunk-7aa03ebd":"9ac7593f","chunk-7f0b7c1c":"6f8c7bad","chunk-bdbf55f4":"79403308","chunk-fb7a909c":"847927c6","chunk-15fcb289":"4822d24b","npm._echarts-wordcloud2.0.0@echarts-wordcloud":"bd31bdc3","chunk-68d5396a":"61c0dd7e","chunk-695bd815":"98d6ffeb","chunk-7a276dce":"b7cae4b4","npm._katex0.6.0@katex":"7d4c4c2f","npm._uslug1.0.4@uslug":"970a7dfd","npm._markdown-it6.1.1@markdown-it":"7a5f2e66","npm._unorm1.6.0@unorm":"3376e5e2","chunk-16050600":"0d6f516f","chunk-56993e80":"5dde3357","npm._antv_layout@0.3.25@@antv":"d3110f6f","npm._antv_g6-core@0.8.24@@antv":"7ec3f71a","npm._antv_algorithm@0.1.26@@antv":"ab276d6c","chunk-7eaa5ff1":"b2be4032","chunk-b94f7ba0":"107e6d49","npm._pdfjs-dist2.6.347@pdfjs-dist":"5e516d5a","chunk-74bc4a6a":"c4245d8f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03ef6d8f":1,"chunk-07ee3900":1,"chunk-0c96d9a1":1,"chunk-0d602ac2":1,"chunk-173ecc1a":1,"chunk-1a201cc9":1,"chunk-1be7006e":1,"chunk-2f078ddd":1,"chunk-6b7734eb":1,"chunk-6bca0f1c":1,"chunk-751da34f":1,"chunk-77df227e":1,"chunk-783635cf":1,"chunk-7850ab1e":1,"chunk-7aa03ebd":1,"chunk-7f0b7c1c":1,"chunk-bdbf55f4":1,"chunk-fb7a909c":1,"chunk-15fcb289":1,"chunk-68d5396a":1,"chunk-695bd815":1,"chunk-7a276dce":1,"chunk-16050600":1,"chunk-56993e80":1,"chunk-7eaa5ff1":1,"chunk-b94f7ba0":1,"chunk-74bc4a6a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm._echarts-wordcloud2.0.0@echarts-wordcloud":"npm._echarts-wordcloud2.0.0@echarts-wordcloud","npm._katex0.6.0@katex":"npm._katex0.6.0@katex","npm._uslug1.0.4@uslug":"npm._uslug1.0.4@uslug","npm._markdown-it6.1.1@markdown-it":"npm._markdown-it6.1.1@markdown-it","npm._unorm1.6.0@unorm":"npm._unorm1.6.0@unorm","npm._antv_layout@0.3.25@@antv":"npm._antv_layout@0.3.25@@antv","npm._antv_g6-core@0.8.24@@antv":"npm._antv_g6-core@0.8.24@@antv","npm._antv_algorithm@0.1.26@@antv":"npm._antv_algorithm@0.1.26@@antv","npm._pdfjs-dist2.6.347@pdfjs-dist":"npm._pdfjs-dist2.6.347@pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-03ef6d8f":"2a95c573","chunk-07ee3900":"c76bd8c9","chunk-0c96d9a1":"30c331e5","chunk-0d602ac2":"731ca38f","chunk-173ecc1a":"5d6170e2","chunk-1a201cc9":"70588a28","chunk-1be7006e":"05ab458f","chunk-2d0e17b4":"31d6cfe0","chunk-2f078ddd":"7dc212c5","chunk-6b7734eb":"a2a17e64","chunk-6bca0f1c":"63db8830","chunk-751da34f":"b07cc2b3","chunk-77df227e":"5fbedfc0","chunk-783635cf":"41c54187","chunk-7850ab1e":"a7966144","chunk-7aa03ebd":"01a25c59","chunk-7f0b7c1c":"a772de46","chunk-bdbf55f4":"5d7caf1b","chunk-fb7a909c":"96a6705c","chunk-15fcb289":"147391a4","npm._echarts-wordcloud2.0.0@echarts-wordcloud":"31d6cfe0","chunk-68d5396a":"223cb299","chunk-695bd815":"7a62d609","chunk-7a276dce":"502b2641","npm._katex0.6.0@katex":"31d6cfe0","npm._uslug1.0.4@uslug":"31d6cfe0","npm._markdown-it6.1.1@markdown-it":"31d6cfe0","npm._unorm1.6.0@unorm":"31d6cfe0","chunk-16050600":"3c3b0528","chunk-56993e80":"13b64544","npm._antv_layout@0.3.25@@antv":"31d6cfe0","npm._antv_g6-core@0.8.24@@antv":"31d6cfe0","npm._antv_algorithm@0.1.26@@antv":"31d6cfe0","chunk-7eaa5ff1":"1b3869e0","chunk-b94f7ba0":"36de939e","npm._pdfjs-dist2.6.347@pdfjs-dist":"31d6cfe0","chunk-74bc4a6a":"b32d5245"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/knowservePlatform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm._core-js3.41.0@core-js","npm._echarts5.6.0@echarts","npm._lodash4.17.21@lodash","npm._zrender5.6.1@zrender","npm._d3-selection3.0.0@d3-selection","npm._d3-transition3.0.1@d3-transition","npm._axios0.20.0@axios","npm._element-ui2.15.9@element-ui","npm._qs6.14.0@qs","npm._animate.css4.1.1@animate.css","npm._buffer4.9.2@buffer","npm._html2canvas1.4.1@html2canvas","npm._vue-print-nb1.7.5@vue-print-nb","npm._vue-router3.6.5@vue-router","npm._vue2.7.16@vue","npm._vuex3.6.2@vuex","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
